import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable({
    providedIn: 'root'
})
export class OffClickService {
    private clickStartElement?: EventTarget;
    private timeout?: number;

    constructor(app: App, private timeoutService: TimeoutService) {
        if (app.isPlatformBrowser) {
            document.addEventListener(
                'mousedown',
                event => {
                    this.setElement(event.target);
                },
                { capture: true }
            );
            document.addEventListener(
                'touchstart',
                event => {
                    this.setElement(event.target);
                },
                { capture: true }
            );
            document.addEventListener('mouseup', event => this.reset());
            document.addEventListener('touchend', event => this.reset());
        }
    }

    get clickTarget(): EventTarget | undefined {
        return this.clickStartElement;
    }

    private reset() {
        this.timeout = this.timeoutService.setTimeout(() => {
            this.setElement(undefined);
        }, 50);
    }

    private setElement(element) {
        this.clickStartElement = element;
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        }
    }
}
